import createContentRenderer from "./utils/createContentRenderer";

export default function useRezervaceTabs({ datumOd, datumDo, stav }) {
  const RezervaceTabsContentRenderer = createContentRenderer({
    datumOd,
    datumDo,
    stav
  });
  return { contentRenderer: RezervaceTabsContentRenderer };
}
